(function () {
  function cleanVariantId(value) {
    if (!value) return null;
    return String(value).replace(/'/g, '').trim();
  }

  function getWmdLanguage() {
    const path = window.location.pathname.toLowerCase();

    if (path === '/en' || path.startsWith('/en/')) return 'en';
    if (path === '/fr' || path.startsWith('/fr/')) return 'fr';

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      const root = String(Shopify.routes.root).toLowerCase();

      if (root === '/en/' || root.startsWith('/en/')) return 'en';
      if (root === '/fr/' || root.startsWith('/fr/')) return 'fr';
    }

    const htmlLang = document.documentElement.lang || '';

    if (htmlLang.toLowerCase().startsWith('en')) return 'en';
    if (htmlLang.toLowerCase().startsWith('fr')) return 'fr';
    if (htmlLang.toLowerCase().startsWith('de')) return 'de';

    if (window.Shopify && Shopify.locale) {
      const shopifyLocale = String(Shopify.locale).toLowerCase();

      if (shopifyLocale.startsWith('en')) return 'en';
      if (shopifyLocale.startsWith('fr')) return 'fr';
      if (shopifyLocale.startsWith('de')) return 'de';
    }

    return 'de';
  }

  const WMD_TRANSLATIONS = {
    de: {
      cartPropertyName: 'Gestell',
      missingVariantAlert: 'Fehlende Varianten-ID für Tischplatte oder Gestell.',
      cartErrorAlert: 'Konnte nicht in den Warenkorb gelegt werden.',
      visibleTexts: {
        tabletop: 'Tischplatte:',
        selectorTitle: 'Gestell wählen',
        uLegs: 'U-Beine',
        xLegs: 'X-Beine',
        split: 'Stahlplatte Split',
        note: 'Das gewählte Gestell wird automatisch zusammen mit der Tischplatte in den Warenkorb gelegt.'
      },
      legLabels: {
        u: 'U-Beine',
        x: 'X-Beine',
        split: 'Stahlplatte Split'
      }
    },

    en: {
      cartPropertyName: 'Legs',
      missingVariantAlert: 'Missing variant ID for tabletop or table legs.',
      cartErrorAlert: 'Could not add the items to the cart.',
      visibleTexts: {
        tabletop: 'Tabletop:',
        selectorTitle: 'Choose table legs',
        uLegs: 'U legs',
        xLegs: 'X legs',
        split: 'Split steel plate legs',
        note: 'The selected legs are automatically added to the cart together with the tabletop.'
      },
      legLabels: {
        u: 'U legs',
        x: 'X legs',
        split: 'Split steel plate legs'
      }
    },

    fr: {
      cartPropertyName: 'Piètement',
      missingVariantAlert: 'ID de variante manquant pour le plateau ou le piètement.',
      cartErrorAlert: 'Impossible d’ajouter les articles au panier.',
      visibleTexts: {
        tabletop: 'Plateau:',
        selectorTitle: 'Choisir le piètement',
        uLegs: 'Pieds en U',
        xLegs: 'Pieds en X',
        split: 'Piètement en plaque d’acier divisée',
        note: 'Le piètement choisi est automatiquement ajouté au panier avec le plateau.'
      },
      legLabels: {
        u: 'Pieds en U',
        x: 'Pieds en X',
        split: 'Piètement en plaque d’acier divisée'
      }
    }
  };

  const WMD_LANG = getWmdLanguage();
  const WMD_T = WMD_TRANSLATIONS[WMD_LANG] || WMD_TRANSLATIONS.de;

  function replaceTextInNode(root, replacements) {
    if (!root) return;

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          const parent = node.parentElement;
          if (!parent) return NodeFilter.FILTER_REJECT;

          const tag = parent.tagName.toLowerCase();
          if (['script', 'style', 'noscript'].includes(tag)) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach((node) => {
      let text = node.nodeValue;

      replacements.forEach(([from, to]) => {
        text = text.replaceAll(from, to);
      });

      node.nodeValue = text;
    });
  }

  function translateVisibleProductTexts() {
    const t = WMD_T.visibleTexts;

    const replacements = [
      ['tabletop:', t.tabletop],
      ['Tabletop:', t.tabletop],
      ['Tischplatte:', t.tabletop],
      ['Plateau:', t.tabletop],

      ['Gestell wählen', t.selectorTitle],
      ['Choose table legs', t.selectorTitle],
      ['Choisir le piètement', t.selectorTitle],

      ['U Beine', t.uLegs],
      ['U-Beine', t.uLegs],
      ['U legs', t.uLegs],
      ['U Legs', t.uLegs],
      ['Pieds U', t.uLegs],
      ['Pieds en U', t.uLegs],

      ['X Beine', t.xLegs],
      ['X-Beine', t.xLegs],
      ['X legs', t.xLegs],
      ['X Legs', t.xLegs],
      ['Pieds X', t.xLegs],
      ['Pieds en X', t.xLegs],

      ['Stahlplatte Split', t.split],
      ['Steel Plate Split', t.split],
      ['Split steel plate legs', t.split],
      ['Plaque d’acier Split', t.split],
      ["Plaque d'acier Split", t.split],
      ['Piètement en plaque d’acier divisée', t.split],

      [
        'Das Gestell wird automatisch zusammen mit der Tischplatte in den Warenkorb gelegt.',
        t.note
      ],
      [
        'Das gewählte Gestell wird automatisch zusammen mit der Tischplatte in den Warenkorb gelegt.',
        t.note
      ],
      [
        'The selected legs are automatically added to the cart together with the tabletop.',
        t.note
      ],
      [
        'Le piètement choisi est automatiquement ajouté au panier avec le plateau.',
        t.note
      ]
    ];

    document.querySelectorAll('.product-info').forEach((productInfo) => {
      replaceTextInNode(productInfo, replacements);
    });

    document.querySelectorAll('.wmd-leg-options').forEach((legBox) => {
      replaceTextInNode(legBox.closest('fieldset') || legBox.parentElement || legBox, replacements);
    });
  }

  function getSelectedLegVariantId(form) {
    const legBox =
      form.closest('.product-info')?.querySelector('.wmd-leg-options') ||
      document.querySelector('.wmd-leg-options');

    if (!legBox) return null;

    const u = cleanVariantId(legBox.dataset.legU);
    const x = cleanVariantId(legBox.dataset.legX);
    const split = cleanVariantId(legBox.dataset.legSplit);

    const checked = legBox.querySelector('input[name="wmd_leg_choice"]:checked');
    const choice = checked ? checked.value : null;

    if (choice === 'u' && u) return u;
    if (choice === 'x' && x) return x;
    if (choice === 'split' && split) return split;

    return u || x || split || null;
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const data = await res.json().catch(() => null);

    if (!res.ok) {
      const msg = data?.description || data?.message || 'Cart add failed';
      throw new Error(msg);
    }

    return data;
  }

  function getLocalizedCartUrl() {
    const path = window.location.pathname.toLowerCase();

    if (path === '/en' || path.startsWith('/en/')) return '/en/cart';
    if (path === '/fr' || path.startsWith('/fr/')) return '/fr/cart';

    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      const root = String(Shopify.routes.root);

      if (root === '/en/' || root.startsWith('/en/')) return '/en/cart';
      if (root === '/fr/' || root.startsWith('/fr/')) return '/fr/cart';
    }

    return '/cart';
  }

  async function handleProductFormSubmit(e) {
    const form = e.target;

    if (!(form instanceof HTMLFormElement)) return;
    if (!form.action || !form.action.includes('/cart/add')) return;

    const legVariantId = getSelectedLegVariantId(form);
    if (!legVariantId) return;

    e.preventDefault();
    e.stopPropagation();

    if (typeof e.stopImmediatePropagation === 'function') {
      e.stopImmediatePropagation();
    }

    const fd = new FormData(form);
    const topVariantId = cleanVariantId(fd.get('id'));
    const qty = parseInt(fd.get('quantity') || '1', 10);

    if (!topVariantId || !legVariantId) {
      alert(WMD_T.missingVariantAlert);
      return;
    }

    const legChoiceInput =
      form.closest('.product-info')?.querySelector('input[name="wmd_leg_choice"]:checked') ||
      document.querySelector('input[name="wmd_leg_choice"]:checked');

    const legChoice = legChoiceInput?.value || '';
    const legLabel = WMD_T.legLabels[legChoice] || '';

    const submitButtons = form.querySelectorAll('[type="submit"]');

    submitButtons.forEach((btn) => {
      btn.disabled = true;
    });

    try {
      const topItem = {
        id: Number(topVariantId),
        quantity: qty
      };

      await addItems([
        topItem,
        {
          id: Number(legVariantId),
          quantity: qty
        }
      ]);

      window.location.href = getLocalizedCartUrl();
    } catch (err) {
      console.error('WMD add-to-cart error:', err);
      alert(err?.message || WMD_T.cartErrorAlert);
    } finally {
      submitButtons.forEach((btn) => {
        btn.disabled = false;
      });
    }
  }

  function attachProductInfoObservers() {
    document.querySelectorAll('.product-info').forEach((el) => {
      if (el.dataset.wmdObserved) return;
      el.dataset.wmdObserved = '1';

      const localObserver = new MutationObserver(() => {
        translateVisibleProductTexts();
      });

      localObserver.observe(el, {
        childList: true,
        subtree: true
      });
    });
  }

  function initWmdLegBundle() {
    translateVisibleProductTexts();
    attachProductInfoObservers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWmdLegBundle);
  } else {
    initWmdLegBundle();
  }

  document.addEventListener('shopify:section:load', initWmdLegBundle);

  const wmdBodyObserver = new MutationObserver(() => {
    attachProductInfoObservers();
  });

  wmdBodyObserver.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('submit', handleProductFormSubmit, true);
})();
